import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import realSupport from '../../images/LandingPage/people/thankyou-page.svg';
import theWeatherNetworkLogo from '../../images/EapPage/weather-network-logo-clear.svg';
import leagueLogo from '../../images/EapPage/league-logo.svg';
import atbLogo from '../../images/EapPage/atb-logo.png';
import endyLogo from '../../images/EapPage/endy-logo.png';
import lightGreenCheck from '../../images/EapPage/light-green-check.svg';
import FacebookLogo from '../../images/LandingPage/thankyou/facebook.svg';
import InstagramLogo from '../../images/LandingPage/thankyou/instagram.svg';
import LinkedInLogo from '../../images/LandingPage/thankyou/linkedin.svg';
import TwitterLogo from '../../images/LandingPage/thankyou/twitter.svg';
import messages from './messages';

const organizations = [
  {
    id: 0,
    src: theWeatherNetworkLogo,
    alt: 'The Weather Network logo',
    width: '25%',
  },
  {
    id: 1,
    src: leagueLogo,
    alt: 'League logo',
    width: '13%',
  },
  {
    id: 2,
    src: atbLogo,
    alt: 'ATB logo',
    width: '13%',
  },
  {
    id: 3,
    src: endyLogo,
    alt: 'Endy logo',
    width: '13%',
  },
];

export function SectionOne() {
  return (
    <div className="thank-you">
      <div className="container">
        <img
          className="main-image"
          src={realSupport}
          alt="Your mental health partner"
        />
        <div className="text">
          <h2>
            <FormattedMessage {...messages.thankYou} />
          </h2>
          <FormattedHTMLMessage {...messages.beInTouch} />
          <div className="fc-social-link">
            <ul>
              <li>
                <a href="https://www.facebook.com/inkblotpsychotherapy">
                  <img src={FacebookLogo} alt="Twitter" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/inkblottherapy">
                  <img src={InstagramLogo} alt="Instagram" />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/inkblottherapy">
                  <img src={LinkedInLogo} alt="LinkedIn" />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/inkblottherapy">
                  <img src={TwitterLogo} alt="Twitter" />
                </a>
              </li>
            </ul>
          </div>
          <div className="trusted">
            <img src={lightGreenCheck} alt="Light green check" />
            <p>
              <FormattedMessage {...messages.joinOther} />
            </p>
          </div>
          <div className="organizations">
            {organizations.map((org) => (
              <img
                key={org.id}
                src={org.src}
                alt={org.alt}
                style={{ height: 'auto', width: org.width }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

SectionOne.propTypes = {};
